import { DefaultThunk } from "stores";
import { UpdateCharacter } from "stores/modules/entities.room.characters";
import { UpdateDeck } from "stores/modules/entities.room.decks";
import { UpdateDiceItem } from "stores/modules/entities.room.dices";
import { UpdateItem } from "stores/modules/entities.room.items";
import { UpdateMarker } from "stores/modules/entities.rooms";
import {
  deleteObjects,
  updateObjects,
} from "stores/modules/entities.rooms/operations";

type UpdateBase<T, D> = {
  selectType: T;
  id: string;
  data: D;
};

export type UpdateObject =
  | UpdateBase<"item", UpdateItem>
  | UpdateBase<"deck", UpdateDeck>
  | UpdateBase<"marker", UpdateMarker>
  | UpdateBase<"character", UpdateCharacter>
  | UpdateBase<"diceItem", UpdateDiceItem>;

export type UpdateFieldObjectsRecord = {
  kind: "update-field-objects";
  before: UpdateObject[];
  after: UpdateObject[] | null;
};

export const undoUpdateFieldObjects =
  (history: UpdateFieldObjectsRecord): DefaultThunk =>
  (dispatch, getState) => {
    const roomId = getState().app.state.roomId;
    if (!roomId) return;

    dispatch(updateObjects(history.before, roomId));
    return;
  };

export const redoUpdateFieldObjects =
  (history: UpdateFieldObjectsRecord): DefaultThunk =>
  (dispatch, getState) => {
    const roomId = getState().app.state.roomId;
    if (!roomId) return;
    const after = history.after;

    if (!after) {
      dispatch(deleteObjects(history.before, roomId));
      return;
    }

    dispatch(updateObjects(after, roomId));
    return;
  };
